export default {
  // Hero section
  'hero.title': 'Профессиональные онлайн инструменты таймера',
  'hero.subtitle': 'Выберите идеальный инструмент хронометража для ваших нужд',

  // Tool cards
  'timer.title': 'Таймер',
  'timer.description': 'Таймер обратного отсчета для работы, учебы и жизни',
  'timer.longDescription': 'Таймер обратного отсчета для продуктивности, готовки и управления временем',
  'timer.button': 'Запустить таймер',

  'stopwatch.title': 'Секундомер',
  'stopwatch.description': 'Инструмент высокоточного хронометража',
  'stopwatch.longDescription': 'Высокоточный секундомер для спорта, тренировок и точного хронометража',
  'stopwatch.button': 'Запустить секундомер',

  'worldclock.title': 'Мировые часы',
  'worldclock.description': 'Просмотр часовых поясов по всему миру',
  'worldclock.longDescription': 'Отображение в реальном времени времени в крупных городах мира с интеллектуальными расчетами часовых поясов',
  'worldclock.button': 'Посмотреть мировые часы',

  // Features section
  'features.title': 'Почему стоит выбрать timer.today?',
  'features.reliable.title': 'Надежный и точный',
  'features.reliable.desc': 'Хронометраж с точностью до миллисекунды с надежностью на основе браузера',
  'features.crossPlatform.title': 'Кроссплатформенность',
  'features.crossPlatform.desc': 'Безупречная работа на настольных компьютерах, планшетах и мобильных устройствах',
  'features.smartNotifications.title': 'Умные уведомления',
  'features.smartNotifications.desc': 'Звуковые оповещения и уведомления на рабочем столе по истечении времени',
  'features.easyToUse.title': 'Простота использования',
  'features.easyToUse.desc': 'Чистый интерфейс с интуитивно понятными элементами управления для всех пользователей',

  // Keywords section
  'keywords.timer': 'таймер обратный отсчет помодоро фокус работа перерыв',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};